// Masks monetary values to stars for restricted admin accounts.
// Usage:
//   import { fmtMoney } from "../../utils/money";
//   const { user } = useAuth();
//   fmtMoney(value, user)  ->  "★★★★★" if user.is_restricted else "1,234"

export const isRestricted = (user) => Boolean(user && user.is_restricted);

export const MASK = "★★★★★";

/**
 * Returns either the en-US formatted number or the mask string.
 * Falls back gracefully when value is null/undefined.
 */
export const fmtMoney = (value, user) => {
  if (isRestricted(user)) return MASK;
  if (value === null || value === undefined || isNaN(Number(value))) return "0";
  return Number(value).toLocaleString("en-US");
};
